export default __webpack_public_path__ + "static/media/45t.90b967e9.jpg";